module.exports = __webpack_public_path__ + "media/homepage/header-collage@3x-d1a784e1.png";